module.exports = __webpack_public_path__ + "static/media/ico_search.b49e4b8a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ico_search.svg
// module id = 609
// module chunks = 0